import  {__extends} from './eXcell';
import eXcell_edn from './eXcell_edn';
import goingValidation from '../../../dxSource/global/goingValidationClass';
/**
 * 自定义单元格
 * @param cell
 */
var eXcell_custom = (function (_super) {
    __extends(eXcell_custom, _super);
    function eXcell_custom(cell) {
        _super.call(this, cell);
    }
    eXcell_custom.prototype.setValue = function (val) {
        var customFun = this.grid.customAry[this.cell._cellIndex];
        var funName = this.grid.funNameAry[this.cell._cellIndex];
        var gridObj = this.grid;
        var rowId = this.cell.parentNode.idd;
        if (customFun != null) {
            this.cell.innerHTML = this.grid._aplNF(customFun(val, rowId, this.grid), this.cell._cellIndex);
            if (goingValidation.isNotEmpty(funName)) {
                console.log("------1--------------");
                $(this.cell).unbind('click').bind('click',function () {
                    console.log(this.cell,"------2-------------")
                    //判断是否定义了相应的函数
                    if (goingValidation.isNotNull(gridObj.vueObj)) {
                        gridObj.vueObj.$emit("cellClick", {
                            val: val,
                            funName: funName,
                            rowId: rowId
                        });
                    }
                    return true;
                });
            }
        }
    };
    eXcell_custom.prototype.getValue = function () {
        return this.cell.innerText;
    };
    eXcell_custom.prototype.isDisabled = function () {
        return true;
    };
    eXcell_custom.prototype.edit = function () {
        return false;
    };
    return eXcell_custom;
})(eXcell_edn);
window.eXcell_custom = eXcell_custom;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_custom.js